module.exports = __webpack_public_path__ + "img/_5.9967ab6d.png";